export const getData = (state) => state.inputData.data;
export const getTableData = (state) => state.inputData.tableInfo;
export const getIsAct = (state) => state.inputData.isAct;
export const getIsInvoice = (state) => state.inputData.isInvoice;
export const getIsPayment = (state) => state.inputData.isPayment;

